import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import {Box, Grid, Button, Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';
import {Paper, IconButton, Menu, MenuItem, ListItemIcon, ListItemText} from '@material-ui/core';
import {TextField, Select} from '@material-ui/core';
import MoreVert from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

import WifiTethering from '@material-ui/icons/WifiTethering';
import WifiIcon from '@material-ui/icons/Wifi';
import { getBase64ID } from '../../../api/helpers';
import { EXTERNAL_PROTOCOL_TYPES } from '../../api/ServerApi';
//import CellTowerIcon from '@material-ui/icons/CellTower';

//import { sortByLogin } from '../../../api/helpers';

class ExternalNetworksListEditor_ extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            menuAnchor: null
        }
    }

    componentDidUpdate(){
        
    }

    handleNetworkSelect(networkID){
        this.props.onExternalNetworkSelect(networkID)
    }

    getNetworkStyle(networkID){
        let selected = networkID === this.props.selectedNetworkID
        let style = {
            background: selected? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }

    handleMenuClick(event, itemID){
        this.setState({menuAnchor: event.currentTarget, menuItemID: itemID});
        event.stopPropagation();
    }

    handleMenuClose(){
        this.menuAnchor = null;
        this.setState({menuAnchor: null});
        return null;
    }

    handleMenuItemClick(action, externalNetworkID){
        this.handleMenuClose();
        this.props.onAction({type: action, externalNetworkID: externalNetworkID})
    }

    handleMenuAddItemClick(event, type){
        if(type===undefined){
            this.setState({menuAddAnchor: event.currentTarget});
            event.stopPropagation();
        }else{
            let net = this.getNetworkDefaults(type)
            this.props.onAction({type:'EXTERNAL_NETWORK_EDITOR_OPEN_ADD', externalNetwork: net})
            this.setState({menuAddAnchor: null})
        }
    }

    handleMenuAddItemClose(event){
        this.setState({menuAddAnchor: null});
        event.stopPropagation();
    }

    checkLicense(licenseName){
        return this.props.onAction({type: 'LICENSE_CHECK', licenseName: licenseName})
    }

    getNetworkDefaults(type){
        console.log('getNetworkDefaults')
        console.log('type='+type)
        let net = {}

        switch(type){

            case 'Excera':
                net = {
                    Codec: 0,
                    DefaultRadioID: 1000,
                    EnableRadioCheck: 1,
                    EndRtpPort: 8100,
                    FailedCheckCount: 3,
                    GatewayAddress: '',
                    GatewayPort: 6000,
                    Groups: [],
                    ID: getBase64ID(),
                    Name: "Excera Network",
                    ProtocolType: EXTERNAL_PROTOCOL_TYPES.EXCERA,
                    RadioCheckPeriod: 10,
                    RadioInactivityTimeout: 3600,
                    ServerAddress: '',
                    ServerSipPort: 6000,
                    SoundLevel: -25,
                    StartRtpPort: 8000
                }
                break

            case 'Hytera':
                net = {
                    DefaultRadioID: 1,
                    EnableRadioCheck: 1,
                    FailedCheckCount: 3,
                    Groups: [],
                    ID: getBase64ID(),
                    IsXpt: false,
                    Name: "Hytera Network",
                    Port_Slot1_LP: 30003,
                    Port_Slot1_RCP: 30009,
                    Port_Slot1_RRS: 30001,
                    Port_Slot1_RTP: 30012,
                    Port_Slot1_TMP: 30007,
                    Port_Slot2_LP: 30004,
                    Port_Slot2_RCP: 30010,
                    Port_Slot2_RRS: 30002,
                    Port_Slot2_RTP: 30014,
                    Port_Slot2_TMP: 30008,
                    ProtocolType: EXTERNAL_PROTOCOL_TYPES.HYTERA,
                    QuickGps: false,
                    RadioCheckPeriod: 10,
                    RadioInactivityTimeout: 3600,
                    SoundLevel: -25
                }
                break

            case 'Kirisun':
                net = {
                    Codec: 0,
                    DefaultRadioID: 1000,
                    EnableRadioCheck: 1,
                    EndRtpPort: 8100,
                    FailedCheckCount: 3,
                    GatewayAddress: '',
                    GatewayPort: 6000,
                    Groups: [],
                    ID: getBase64ID(),
                    Name: "Kirisun Network",
                    ProtocolType: EXTERNAL_PROTOCOL_TYPES.KIRISUN,
                    RadioCheckPeriod: 10,
                    RadioInactivityTimeout: 3600,
                    ServerAddress: '',
                    ServerSipPort: 6000,
                    SoundLevel: -25,
                    StartRtpPort: 8000
                }
                break

            case 'Caltta':
                net = {
                    Codec: 8,
                    DefaultRadioID: 16775914,
                    EnableRadioCheck: 1,
                    EndRtpPort: 8100,
                    FailedCheckCount: 3,
                    GatewayAddress: '',
                    GatewayPort: 19888,
                    Groups: [],
                    ID: getBase64ID(),
                    Name: 'Caltta Network',
                    ProtocolType: EXTERNAL_PROTOCOL_TYPES.CALTTA,
                    RadioCheckPeriod: 10,
                    RadioInactivityTimeout: 3600,
                    ServerAddress: '',
                    ServerSipPort: 19888,
                    SoundLevel: -25,
                    StartRtpPort: 8000
                }
                break

            default:
                console.error('getNetworkDefaults(): unknown type = ' + type)
        }
        console.log(net)
        return net
    }


    render(){

        console.log('render ExternalNetworksListEditor')
        console.log(this.props)

        const {t} = this.props

        console.log(this.props.externalNetworks)
        if(!this.props.externalNetworks) return ''

        console.log('render this.props.externalNetworks')
        console.log(this.props.externalNetworks)

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            addIcon: {
                color: 'white'
            }
        };

        let exceraEnabled = this.checkLicense('AisDmr')
        let calttaEnabled = this.checkLicense('CalttaDmr')
        let hyteraEnabled = this.checkLicense('HyteraDmr')
        let kirisunEnabled = this.checkLicense('KirisunDmr')

        return(
        <Paper style={styles.paper}>    

            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell colSpan={1} style={styles.head}></TableCell>
                        <TableCell style={styles.head}>{t('Name')}</TableCell>
                        <TableCell style={{...styles.head, width:40}}>
                            <IconButton size="small" color="primary" aria-label="more" component="span"
                                style={styles.addIcon}
                                onClick={(event)=>{this.handleMenuAddItemClick(event)}}>
                                <AddCircleOutlineIcon />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {this.props.externalNetworks.map((net) => 
                    <TableRow key={net.ID} 
                            onClick={()=>{this.handleNetworkSelect(net.ID)}}
                            onDoubleClick={()=>{this.handleMenuItemClick('EXTERNAL_NETWORK_EDITOR_OPEN_EDIT', net.ID)}}
                            style={this.getNetworkStyle(net.ID)}>

                        <TableCell style={{width:40}} component="th" scope="row">
                            <WifiIcon color="primary" />
                        </TableCell>
                        <TableCell component="th" scope="row">
                            {net.Name}
                        </TableCell>
                        <TableCell style={{width:40}}>
                            <IconButton size="small" color="inherit" aria-label="add" component="span"
                                onClick={event=>this.handleMenuClick(event, net.ID)}>
                                <MoreVert />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                )}
                </TableBody>

                <Menu anchorEl={this.state.menuAnchor} keepMounted
                    open={Boolean(this.state.menuAnchor)} onClose={this.handleMenuClose.bind(this)}>
                    <MenuItem onClick={()=>{this.handleMenuItemClick('EXTERNAL_NETWORK_EDITOR_OPEN_EDIT', this.state.menuItemID)}}>
                        <ListItemIcon color="primary"><EditIcon/></ListItemIcon> 
                        <ListItemText primary={t('EditDmrNetwork')+'...'} />
                    </MenuItem>
                    <MenuItem onClick={()=>{this.handleMenuItemClick('EXTERNAL_NETWORK_EDITOR_DELETE', this.state.menuItemID)}}>
                        <ListItemIcon><DeleteForeverIcon/></ListItemIcon>
                        <ListItemText primary={t('DeleteDmrNetwork')} />
                    </MenuItem>
                </Menu>

                <Menu anchorEl={this.state.menuAddAnchor} keepMounted
                    open={Boolean(this.state.menuAddAnchor)} onClose={this.handleMenuAddItemClose.bind(this)}>
                    {exceraEnabled ? (<MenuItem onClick={(event)=>{this.handleMenuAddItemClick(event, 'Excera')}}>{t('NewExceraNetwork')}</MenuItem>) : ''}
                    {hyteraEnabled ? (<MenuItem onClick={(event)=>{this.handleMenuAddItemClick(event, 'Hytera')}}>{t('NewHyteraNetwork')}</MenuItem>) : ''}
                    {kirisunEnabled ? (<MenuItem onClick={(event)=>{this.handleMenuAddItemClick(event, 'Kirisun')}}>{t('NewKirisunNetwork')}</MenuItem>) : ''}
                    {calttaEnabled ? (<MenuItem onClick={(event)=>{this.handleMenuAddItemClick(event, 'Caltta')}}>{t('NewCalttaNetwork')}</MenuItem>) : ''}
                </Menu>

            </Table>
        </Paper>
        )

    }

}

export const ExternalNetworksListEditor = withTranslation()(ExternalNetworksListEditor_);